import {
  FilingReportConfirmation,
  NormalizedSellerFilingReport,
} from '@/core/types';

export interface GroupedReports {
  [correctionType: string]: FilingReportConfirmation[];
}

export const groupByCorrectionType = (
  reports: NormalizedSellerFilingReport[]
): GroupedReports => {
  return reports.reduce((acc: GroupedReports, item) => {
    const correctionType = item.correction_type || 'report';

    const existingGroup = acc[correctionType];

    if (item.confirmation && item.confirmation.id) {
      if (existingGroup) {
        const existingConfirmation = existingGroup.find(
          (confirmation) => confirmation.id === item.confirmation.id
        );

        if (existingConfirmation) {
          const newDocuments = item.confirmation.documents.filter(
            (doc) =>
              !existingConfirmation.documents.some(
                (existingDoc) => existingDoc.id === doc.id
              )
          );

          existingConfirmation.documents.push(...newDocuments);
        } else {
          existingGroup.push(item.confirmation);
        }
      } else {
        acc[correctionType] = [item.confirmation];
      }
    }

    return acc;
  }, {} as GroupedReports);
};
